import React from "react";
import DetailsSection from "./details-section";
import { Formik, Form, FieldArray } from "formik";
import { Col, Row } from "react-flexbox-grid";
import {
	FormControl,
	Select,
	MenuItem,
	withStyles,
	TextField,
	Button,
	Divider,
	Typography
} from "@material-ui/core";
import PropTypes from "prop-types";
import BorderZone from "../../border-zone";
import AddStratifiers from "./addStratifiers";

const styles = (theme) => ({
	textField: {
		marginBottom: 24
	},
	button: {
		margin: theme.spacing.unit * 2
	}
});

/**
 * Componente para la configuración analítica
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0
 */
const AnalyticalConfiguration = ({
	classes,
	onSubmit,
	indicatorId,
	indicator
}) => {
	return (
		<DetailsSection title="Configuración analítica">
			<Formik
				initialValues={{
					demographic: indicator.demographicVariable || "",
					order: indicator.order || "",
					name: "",
					stratifiersOrder: "",
					stratifiers: indicator.stratifiers,
					constant: indicator.constant || ""
				}}
				onSubmit={(values, bag) => {
					const { generalities, inequalities, tags } = indicator;
					const newValues = Object.assign({}, indicator, {
						demographicVariable: values.demographic,
						order: values.order,
						stratifiers: values.stratifiers,
						tags: tags.map((item) => (item._id ? item._id : item)),
						generalities: {
							description: generalities.description,
							files: generalities.files.map((item) =>
								item.id ? item.id : item
							)
						},
						inequalities: {
							description: inequalities.description,
							files: inequalities.files.map((item) =>
								item.id ? item.id : item
							)
						},
						constant: values.constant
					});
					onSubmit({
						variables: { id: indicatorId, indicator: newValues }
					}).then(() => {
						bag.setSubmitting(false);
					});
				}}
			>
				{({ values, handleChange, isSubmitting, setFieldValue }) => {
					return (
						<Form autoComplete="false">
							<Row>
								<Col xs={12} md={6}>
									<BorderZone title="Estratificadores">
										<FieldArray name="stratifiers">
											{(helpers) => (
												<AddStratifiers
													values={values}
													helpers={helpers}
													handleChange={handleChange}
													setFieldValue={setFieldValue}
												/>
											)}
										</FieldArray>
									</BorderZone>
								</Col>
								<Col xs={12} md={6}>
									<BorderZone>
										<TextField
											name="demographic"
											id="demographic-variable"
											label="Variable demográfica"
											margin="normal"
											variant="outlined"
											className={classes.textField}
											fullWidth
											value={values.demographic}
											onChange={handleChange}
											InputLabelProps={{
												shrink: true
											}}
										/>
										<TextField
											select
											name="constant"
											label="Constante del indicador"
											className={classes.textField}
											value={values.constant}
											onChange={handleChange}
											margin="normal"
											variant="outlined"
											fullWidth
											InputLabelProps={{
												shrink: true
											}}
										>
											<MenuItem value="HUNDRED">100</MenuItem>
											<MenuItem value="THOUSAND">1.000</MenuItem>
											<MenuItem value="TEN_THOUSAND">10.000</MenuItem>
											<MenuItem value="HUNDRED_THOUSAND">100.000</MenuItem>
										</TextField>
										<FormControl fullWidth variant="outlined">
											<Typography
												className="text-gray-600"
												style={{ marginLeft: 12 }}
												variant="caption"
											>
												Ordenamiento
											</Typography>
											<Select
												name="order"
												value={values.order}
												onChange={handleChange}
												displayEmpty
											>
												<MenuItem value="ASC">Ascendente</MenuItem>
												<MenuItem value="DESC">Descendente</MenuItem>
											</Select>
										</FormControl>
									</BorderZone>
								</Col>
							</Row>
							<Divider />
							<Row end="xs">
								<Col xs>
									<Button
										variant="contained"
										color="primary"
										className={classes.button}
										type="submit"
										disabled={isSubmitting}
									>
										Guardar configuración analítica
									</Button>
								</Col>
							</Row>
						</Form>
					);
				}}
			</Formik>
		</DetailsSection>
	);
};

AnalyticalConfiguration.propTypes = {
	classes: PropTypes.object
};

export default withStyles(styles)(AnalyticalConfiguration);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/analytical-configuration.js